import { breadcrumb } from './breadcrumb';
export const call_tracking = {
  breadcrumb,

  number: {
    field: {
      number: 'Телефон',
      status: 'Статус',
      created_at: 'Дата добавления',
      client_id: 'ID Клиента',
      call_date: 'Дата звонка',
      caller_number: 'Телефон звонившего'
    },

    modal: {
      remove: {
        content: 'Вы действительно хотите перестать использовать номер {number} для коллтрекинга?'
      }
    }
  },

  integration: {
    connect: 'Подключение',
    connect_desc: `Вставьте показанный ниже фрагмент на страницу сайта непосредственно после тега <code>&lt;head&gt;</code>. Вместо CLIENT_ID укажите уникальный идентификатор посетителя.`,
    get_number: 'Получение номера',
    get_number_desc: 'Здесь будет доступный телефонный номер'
  },

  button: {
    create: 'Добавить номер'
  }
};
